import * as i from 'types';

import styled from 'styled-components';

import { getColor } from 'styles/utils';

export const ColoredSpan = styled.span<ColoredSpanProps>`
  color: ${({ theme, variant }) => getColor(theme, variant || 'primary')};
`;

type ColoredSpanProps = {
  variant?: i.TextColors;
};
